export default __webpack_public_path__ + "static/quadrant-text-regular-815c38e06eb47f91d32f7be5eab5ea30.woff2";